class Filters {
  categories;
  city_terms;
  date;
  constructor() {
    this.categories = document.querySelector('select[data-trigger="categories"]');
    this.city_terms = document.querySelector('select[data-trigger="city_terms"]');
    this.date = document.querySelector('select[data-trigger="date"]');
    if(this.categories && this.city_terms && this.date){
      this._init();
    }
  }

  _init() {
    this.categories.addEventListener('change', () => {
      console.log("categories")
      this.changeSelect();
    });

    this.city_terms.addEventListener('change', () => {
      console.log("city_terms")

      this.changeSelect();

    });

    this.date.addEventListener('change', () => {
      console.log("date")

      this.changeSelect();

    });
  }

  changeSelect(): void{
    let categories: any = document.querySelector('select[data-trigger="categories"]');
    let city_terms: any = document.querySelector('select[data-trigger="city_terms"]');
    let date: any = document.querySelector('select[data-trigger="date"]');

    categories = categories ? categories.value : '';
    city_terms =  city_terms ? city_terms.value : '';
    date =  date ? date.value : '';
    
    // Construire l'URL avec les valeurs sélectionnées
    const url =
    document.location.origin + '/' + document.location.pathname.split('/')[1]+
      `?categories=${categories}&city_terms=${
        city_terms
      }&date=${date}`;

    // Rediriger vers l'URL avec les valeurs sélectionnées
    window.location.href = url;

  }
}
export const filters = new Filters();
